import { useState } from 'react';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import styles from "../../../styles/adminspace.module.css";
import { displaySelector } from '../../../features/display/displaySlice';
import { useSelector } from 'react-redux';
import ServicePanel from '../../../features/servicePanel/ServicePanel';
import useOnlineStatus from "../../../common/utils/OnlineStatusProvider";
import Offline from "../../../common/pages/Offline";




function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

/** ------------------------------------------------------------------------ */

const Adminspace = () => {
  const isOnline = useOnlineStatus();
  const [value, setValue] = useState(0);
  const display = useSelector(displaySelector)

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if(isOnline){

    return (<>
        <div className={display.isDisplaySidebar ?  styles.contentPageReduce : styles.contentPageFull}>
            <h1>Espace de gestion administrateur</h1>

            <br/>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Services" {...a11yProps(0)} />
                    <Tab label="Agents" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <ServicePanel />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    Agents
                </TabPanel>
                
            </Box>
        </div>
      </>)
  }else{
    return <Offline />
  }
}

export default Adminspace;